import { render } from "./AssistantResultCards.vue?vue&type=template&id=be601198&scoped=true"
import script from "./AssistantResultCards.vue?vue&type=script&lang=js"
export * from "./AssistantResultCards.vue?vue&type=script&lang=js"

import "./AssistantResultCards.vue?vue&type=style&index=0&id=be601198&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be601198"]])

export default __exports__